/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { getSVGIconForDocument } from "cms/documents/document/helpers";

const DocumentFormatCardIcon = (props) => {

    const {
        document,
        onClickHandler,
        children
    } = props || {};

    return (
        <Fragment>
            {document ? (
                <div
                    className='document-gallery-card-frame'
                    onClick={onClickHandler}
                >
                    <div className='document-gallery-icon' >
                        {getSVGIconForDocument(document)}
                    </div>
                    <div className='document-gallery-heading'>
                        {document.title}
                    </div>
                    {children}
                </div>
            ) : null}
        </Fragment>
    );
};

export { DocumentFormatCardIcon };
